<template>
  <motion.div
    class="workspace-role-denied"
    :initial="{ opacity: 0, y: 12 }"
    :animate="{ opacity: 1, y: 0 }"
  >
    <div class="denied-card">
      <div class="denied-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
        </svg>
      </div>
      <h1>{{ t('workspaceDenied.title') }}</h1>
      <p v-html="t('workspaceDenied.message', { area: areaLabel })" />
      <p class="denied-hint">
        {{ t('workspaceDenied.hint') }}
      </p>
      <motion.button
        type="button"
        class="denied-back"
        :whileHover="{ scale: 1.02 }"
        :whileTap="{ scale: 0.98 }"
        @click="goBack"
      >
        {{ t('workspaceDenied.back') }}
      </motion.button>
    </div>
  </motion.div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { motion } from 'motion-v'

const props = defineProps({
  area: { type: String, default: '' }
})

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const areaLabel = computed(() => props.area || t('workspaceDenied.defaultArea'))

const goBack = () => {
  const id = route.params.id
  if (id) {
    router.push(`/workspace/${id}/kanban`)
  } else {
    router.push('/workspaces')
  }
}
</script>

<style scoped>
.workspace-role-denied {
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
}
.denied-card {
  max-width: 480px;
  text-align: center;
  padding: 40px 32px;
  border-radius: 20px;
  border: 1px solid var(--border-primary);
  background: linear-gradient(180deg, var(--bg-secondary), var(--bg-primary));
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.15);
}
.denied-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, #f59e0b 18%, transparent);
  border: 1px solid color-mix(in srgb, #f59e0b 35%, var(--border-primary));
}
.denied-icon svg {
  width: 32px;
  height: 32px;
  color: #f59e0b;
}
.denied-card h1 {
  margin: 0 0 12px;
  font-size: 1.75rem;
  font-weight: 800;
}
.denied-card p {
  margin: 0 0 10px;
  color: var(--text-secondary);
  line-height: 1.55;
}
.denied-hint {
  font-size: 14px;
  margin-bottom: 24px !important;
}
.denied-back {
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  background: var(--accent-primary);
}
</style>
